import {resourcesSliceFactory} from "../../../../setup/redux/slice/resourcesSlice";

export const slice = resourcesSliceFactory('pricingList');
